import React from "react";
import { useTranslation } from "@ca-dmv-radv/translation";
import { Alert, ALERT_SUCCESS } from "@ca-dmv/core";

export default function ReadyToSubmit({ skipDmv }) {
  const { t } = useTranslation();

  // Show only when skipDmv is undefined
  if (skipDmv !== undefined) {
    return null;
  }

  return (
    <Alert
      alertStyle={ALERT_SUCCESS}
      containerClass="mt-48 mb-0 max-width--600"
      hasBorder={false}
      role="alert"
    >
      <h4 className="text--primary text--700 mb-8">
        {t(
          "screens-Dashboard-readyToSubmit",
          "Your documents have been verified and are ready to submit."
        )}
      </h4>
      <p className="text--blue-dark-2">
        {t(
          "screens-Dashboard-readyToSubmit-explanation-1",
          "A visit to the DMV is the final step in your REAL ID application."
        )}
      </p>
    </Alert>
  );
}
